module.exports = __webpack_public_path__ + "static/media/recurAzul.98cccba8.png";